import { render, staticRenderFns } from "./StepInformation.vue?vue&type=template&id=e4f45dde&"
import script from "./StepInformation.vue?vue&type=script&lang=js&"
export * from "./StepInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4f45dde')) {
      api.createRecord('e4f45dde', component.options)
    } else {
      api.reload('e4f45dde', component.options)
    }
    module.hot.accept("./StepInformation.vue?vue&type=template&id=e4f45dde&", function () {
      api.rerender('e4f45dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61808000-5/external/StepInformation.vue"
export default component.exports